import { cn } from "@swivu/shared-ui/src/private/utils.js";

type HorizontalWrapperProps = {
  children?: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const HorizontalWrapper = ({
  children,
  className,
  ...props
}: HorizontalWrapperProps) => {
  return (
    <div
      {...props}
      className={cn(
        `mx-auto max-w-screen-lg px-4  lg:pl-8 lg:pr-0 `,
        className
      )}
    >
      {children}
    </div>
  );
};

export default HorizontalWrapper;
